export default (appFolder: string) => {
  const icons = {
    "app-manifest": "manifest.json",
    "icon-apple": "apple-touch-icon.png",
    "icon-32": "favicon-32x32.png",
    "icon-16": "favicon-16x16.png"
  };

  Object.entries(icons).forEach(([id, path]) => {
    const element = document.getElementById(id) as HTMLLinkElement;
    if (element) {
      element.href = `${appFolder}/${path}`;
    }
  });
};
